import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {Font} from 'pepsico-ds'
import {useCallback} from 'react'
import {ComboProductQuantityRow} from './ComboProductQuantityRow'

export const ComboProductQuantity = () => {
  const {
    productCombo: {comboSkus},
    setProductCombo,
  } = useProductCombo()

  const handleUpdateProductQuantity = useCallback(
    (productId, quantity) => {
      setProductCombo(previousProductCombo => ({
        ...previousProductCombo,
        comboSkus: previousProductCombo.comboSkus.map(currentProduct =>
          currentProduct.productId === productId ? {...currentProduct, quantity} : currentProduct
        ),
      }))
    },
    [setProductCombo]
  )

  return (
    <div className="flex flex-col gap-6 rounded-lg bg-gray-850 p-6">
      <Font variant="bold">Product Table</Font>
      <Font size="xsmall">At least 2 products are required. There is no maximum limit.</Font>
      <div className="h-px bg-gray-600" />
      {comboSkus?.map(product => (
        <ComboProductQuantityRow
          key={product.productId}
          product={product}
          onUpdateProductQuantity={handleUpdateProductQuantity}
        />
      ))}
    </div>
  )
}
